module.exports = __webpack_public_path__ + "static/media/image1.1ab42f16.jpg";